import React, { useContext, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import './Summary.scss';
import { ExtraDataContext } from '../../Context/ExtraDataContext'
import { Icon } from '@material-ui/core';
const Summary = ({ summaryArrData, summaryTitle }) => {
    // console.log(summaryArrData);
    const { isDarkTheme } = useContext(ExtraDataContext);
    const [summaryQuery, setSummaryQuery] = useState('today');


    return (
        <div className="py-3" id="summary">
            <div className="row summaryHeader">
                <div className="summaryHeader__title d-flex justify-content-between ">
                    <h5>{summaryTitle}</h5>
                    <Dropdown>
                        <Dropdown.Toggle variant="none" id="dataQueryBtn" className={`${isDarkTheme ? 'DEFAULT_COLOR DEFAULT_DARK_HOVER' : ''} d-flex align-items-center justify-content-between px-0`}>
                            {summaryQuery} <Icon>expand_more</Icon>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item as="button" onClick={() => setSummaryQuery('today')}>
                                Today
                            </Dropdown.Item>
                            <Dropdown.Item as="button" onClick={() => setSummaryQuery('this week')}>
                                This Week
                            </Dropdown.Item>
                            <Dropdown.Item as="button" onClick={() => setSummaryQuery('this month')}>
                                This Month
                            </Dropdown.Item>
                            <Dropdown.Item as="button" onClick={() => setSummaryQuery('this year')}>
                                This Year
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
            <div className="row summaryBody">
                {summaryArrData?.map((data, index) => (
                    <div key={index} className="col-lg-3 px-0 mb-2 rounded">
                        <div className={`d-flex align-items-center summaryBody__item h-auto bg-white py-3 mx-4 px-2
                        `}>
                            <div className="summaryBody__item__img">
                                <img src={data.img} alt="" />
                            </div>
                            <div className="summaryBody__item__content px-3 ">
                                <h6>{data.name}</h6>
                                <p>{data.price}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Summary;